/* jshint maxparams: 16 */
import _ from 'underscore';
import Backbone from 'backbone';
import LatestTradeListView from '../instrument-detail/latest-trade-list';

export default Backbone.View.extend({
	initialize: function() {
		this.latestTradeList = new LatestTradeListView({ el: '.js-latest-digital-trade-list' })
	},

	render: function() {
		this.latestTradeList.render();
		this.latestTradeList.update();
		return this;
	}
});
